<template>
  <generic-modal
    :width="errorModal.width"
    :modalClass="errorModal.modalClass"
    :height="errorModal.height"
  >
    <template v-slot:header></template>
    <template v-slot:body>
      <div>
        <error-screen
          :data-image="staticImgBaseUrl + '/images/global/img-server-error.svg'"
          :data-title="'Something went wrong'"
          :data-sub-title="'We are trying to fix this issue'"
          :data-cta="'Try again'"
        ></error-screen>
      </div>
    </template>
    <template v-slot:footer>
      <div></div>
    </template>
  </generic-modal>
</template>

<script>
import ErrorScreen from "./ErrorScreen.vue";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
export default {
  components: { ErrorScreen },
  name: "ServerErrorScreen",
  data() {
    return {
      staticImgBaseUrl,
      errorModal: {
        width: "100vw",
        height: "100%",
        modalClass: "full-screen-popup",
      },
    };
  },
  methods:{
    reloadPage(){
      Utility.reloadPage();
    }
  }
};
</script>
